/* AvailablePackagesListRenderer.js */

"use strict";
const _ = require("lodash");
const RepoExpansionPanel = require("../repoexpansionpanel/RepoExpansionPanelComponent");

class AvailablePackagesListRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("available-packages-list-gl");
        this._rootElem.component = this._model;

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();
        let shutdownProms = this._shutdownRepoListComponents();

        this._rootElem.remove();
        this._rootElem = undefined;

        this._model = undefined;

        return Promise.all(shutdownProms);
    }
    _registerListeners() {
        this._model.on("Shutdown", (this._onShutdown = this._onShutdown.bind(this)));
        this._model.on("AvailablePackagesReplaced", (this._onAvailablePackagesReplaced = this._onAvailablePackagesReplaced.bind(this)));
        this._model.on("ExpandAll", (this._onExpandAll = this._onExpandAll.bind(this)));
        this._model.on("CollapseAll", (this._onCollapseAll = this._onCollapseAll.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("Shutdown", this._onShutdown);
        this._model.removeListener("AvailablePackagesReplaced", this._onAvailablePackagesReplaced);
        this._model.removeListener("ExpandAll", this._onExpandAll);
        this._model.removeListener("CollapseAll", this._onCollapseAll);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._rebuildList();
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onShutdown() {
        this._shutdown();
    }
    _onAvailablePackagesReplaced() {
        this.render();
    }
    _onExpandAll() {
        if (!_.isEmpty(this._repoListComponents)) {
            this._repoListComponents.forEach((repoComponent) => {
                repoComponent.expand();
            });
        }
    }
    _onCollapseAll() {
        if (!_.isEmpty(this._repoListComponents)) {
            this._repoListComponents.forEach((repoComponent) => {
                repoComponent.collapse();
            });
        }
    }
    _onLaunchEditor(editorState, editorName, opts) {
        this._model.launchEditor(editorState, editorName, opts);
    }
    _onRepoExpansionPanelCollapsed(repoInfo) {
        this._model.collapse(repoInfo.repository.id);
    }
    _onRepoExpansionPanelExpanded(repoInfo) {
        this._model.expand(repoInfo.repository.id);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _shutdownRepoListComponents() {
        let shutdownProms = [];

        //teardown repolist components
        if (!_.isEmpty(this._repoListComponents)) {
            this._repoListComponents.forEach((repoComponent) => {
                shutdownProms.push(repoComponent.shutdown());
                repoComponent.removeListener("LaunchEditor", this._onLaunchEditor);
                repoComponent.removeListener("RepoCollapsed", this._onRepoExpansionPanelCollapsed);
                repoComponent.removeListener("RepoExpanded", this._onRepoExpansionPanelExpanded);
            });
        }
        this._repoListComponents = undefined;
        return shutdownProms;
    }
    _rebuildList() {
        let startUpProms = [];
        let shutdownProms = this._shutdownRepoListComponents();

        //Rebuild the _repoListComponents
        this._rootElem.innerHTML = "";
        //TODO add SORTing
        this._repoListComponents = [];
        let availablePackages = this._model.getAvailablePackages();

        if (_.isEmpty(availablePackages)) {
            this._rootElem.innerHTML = `
                <p class="no_available_packages">No Packages Found.</p>
            `;
        } else {
            Object.keys(availablePackages).forEach((repoId) => {
                let repoSummary = availablePackages[repoId];
                let repoComponent = new RepoExpansionPanel(repoSummary);
                this._repoListComponents.push(repoComponent);
                startUpProms.push(repoComponent.renderer.render());
                this._rootElem.appendChild(repoComponent.renderer.rootElement);

                if (this._model.isExpanded(repoId)) {
                    repoComponent.expand();
                }

                repoComponent.on("LaunchEditor", (this._onLaunchEditor = this._onLaunchEditor.bind(this)));
                repoComponent.on("RepoCollapsed", (this._onRepoExpansionPanelCollapsed = this._onRepoExpansionPanelCollapsed.bind(this)));
                repoComponent.on("RepoExpanded", (this._onRepoExpansionPanelExpanded = this._onRepoExpansionPanelExpanded.bind(this)));
            });
        }
        return Promise.all(shutdownProms.concat(startUpProms));
    }
    /*******************************************/
    /* END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = AvailablePackagesListRenderer;
